export default __webpack_public_path__ + "static/9-99cea855fa6a8ad3b6519293ad6559ae.jpg";